module.exports = __webpack_public_path__ + "img/de.50d8cf9d.svg";